/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClimateMapPageResponse } from '../models/climate-map-page-response';
import { DeviceEventPageDto } from '../models/device-event-page-dto';
import { getAnalysisPageData } from '../fn/telemetry/get-analysis-page-data';
import { GetAnalysisPageData$Params } from '../fn/telemetry/get-analysis-page-data';
import { getAverageTelemetryDataByHouse } from '../fn/telemetry/get-average-telemetry-data-by-house';
import { GetAverageTelemetryDataByHouse$Params } from '../fn/telemetry/get-average-telemetry-data-by-house';
import { getClimateMapPageData } from '../fn/telemetry/get-climate-map-page-data';
import { GetClimateMapPageData$Params } from '../fn/telemetry/get-climate-map-page-data';
import { getDeviceIotEvents } from '../fn/telemetry/get-device-iot-events';
import { GetDeviceIotEvents$Params } from '../fn/telemetry/get-device-iot-events';
import { getFacilityIotEvents } from '../fn/telemetry/get-facility-iot-events';
import { GetFacilityIotEvents$Params } from '../fn/telemetry/get-facility-iot-events';
import { getSensorPageData } from '../fn/telemetry/get-sensor-page-data';
import { GetSensorPageData$Params } from '../fn/telemetry/get-sensor-page-data';
import { InsightData } from '../models/insight-data';
import { IoTEventResponse } from '../models/io-t-event-response';
import { SensorPageDto } from '../models/sensor-page-dto';

@Injectable({ providedIn: 'root' })
export class TelemetryService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAnalysisPageData()` */
  static readonly GetAnalysisPageDataPath = '/api/telemetry/analysis';

  /**
   * Get Analysis Page Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAnalysisPageData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnalysisPageData$Response(params: GetAnalysisPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<SensorPageDto>> {
    return getAnalysisPageData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Analysis Page Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAnalysisPageData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAnalysisPageData(params: GetAnalysisPageData$Params, context?: HttpContext): Observable<SensorPageDto> {
    return this.getAnalysisPageData$Response(params, context).pipe(
      map((r: StrictHttpResponse<SensorPageDto>): SensorPageDto => r.body)
    );
  }

  /** Path part for operation `getAverageTelemetryDataByHouse()` */
  static readonly GetAverageTelemetryDataByHousePath = '/api/telemetry/averages/facilityId/{facilityId}';

  /**
   * Get Average Telemetry Data By House.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAverageTelemetryDataByHouse()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAverageTelemetryDataByHouse$Response(params: GetAverageTelemetryDataByHouse$Params, context?: HttpContext): Observable<StrictHttpResponse<InsightData>> {
    return getAverageTelemetryDataByHouse(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Average Telemetry Data By House.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAverageTelemetryDataByHouse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAverageTelemetryDataByHouse(params: GetAverageTelemetryDataByHouse$Params, context?: HttpContext): Observable<InsightData> {
    return this.getAverageTelemetryDataByHouse$Response(params, context).pipe(
      map((r: StrictHttpResponse<InsightData>): InsightData => r.body)
    );
  }

  /** Path part for operation `getClimateMapPageData()` */
  static readonly GetClimateMapPageDataPath = '/api/telemetry/climate-map';

  /**
   * Get Climate Map Page Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClimateMapPageData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClimateMapPageData$Response(params?: GetClimateMapPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<ClimateMapPageResponse>> {
    return getClimateMapPageData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Climate Map Page Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClimateMapPageData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClimateMapPageData(params?: GetClimateMapPageData$Params, context?: HttpContext): Observable<ClimateMapPageResponse> {
    return this.getClimateMapPageData$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClimateMapPageResponse>): ClimateMapPageResponse => r.body)
    );
  }

  /** Path part for operation `getDeviceIotEvents()` */
  static readonly GetDeviceIotEventsPath = '/api/telemetry/device/events';

  /**
   * Get Device Iot Events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceIotEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceIotEvents$Response(params?: GetDeviceIotEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceEventPageDto>> {
    return getDeviceIotEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Device Iot Events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeviceIotEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceIotEvents(params?: GetDeviceIotEvents$Params, context?: HttpContext): Observable<DeviceEventPageDto> {
    return this.getDeviceIotEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceEventPageDto>): DeviceEventPageDto => r.body)
    );
  }

  /** Path part for operation `getFacilityIotEvents()` */
  static readonly GetFacilityIotEventsPath = '/api/telemetry/raw/events';

  /**
   * Get Facility Iot Events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityIotEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityIotEvents$Response(params?: GetFacilityIotEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<IoTEventResponse>>> {
    return getFacilityIotEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Iot Events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityIotEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityIotEvents(params?: GetFacilityIotEvents$Params, context?: HttpContext): Observable<Array<IoTEventResponse>> {
    return this.getFacilityIotEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<IoTEventResponse>>): Array<IoTEventResponse> => r.body)
    );
  }

  /** Path part for operation `getSensorPageData()` */
  static readonly GetSensorPageDataPath = '/api/telemetry/sensor';

  /**
   * Get Sensor Page Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSensorPageData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSensorPageData$Response(params: GetSensorPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<SensorPageDto>> {
    return getSensorPageData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Sensor Page Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSensorPageData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSensorPageData(params: GetSensorPageData$Params, context?: HttpContext): Observable<SensorPageDto> {
    return this.getSensorPageData$Response(params, context).pipe(
      map((r: StrictHttpResponse<SensorPageDto>): SensorPageDto => r.body)
    );
  }

}
